export default {"src":"/_next/static/media/google.b25560ab.svg","height":27,"width":26,"blurWidth":0,"blurHeight":0};